<template>
  <div class="">
    <el-upload
      :class="{ uoloadSty: showBtnDealImg, disUoloadSty: noneBtnImg }"
      action="actionUpload"
      :http-request="companyCpload"
      :on-change="dealImgChange"
      list-type="picture-card"
      :before-upload="beforeAvatarUpload"
      :file-list="companyUploadList"
      :auto-upload="true"
    >
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }" style="height: 100%;">
        <!-- <template v-if="fileUrlList.length==0"> -->
          <img  v-if="file.raw.type!='application/pdf'" class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
          <embed v-if="file.raw.type=='application/pdf'" class="el-upload-list__item-thumbnail" :src="file.url"  type="">
          <!-- <el-progress  type="circle" v-if="videoFlag&&limitCountImg==1" :status="videoStatus" :percentage="videoUploadPercent"></el-progress> -->
        <!-- </template> -->
        <!-- <template v-else>
          <img  class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        </template> -->
        <!-- <img v-if="file.raw.type!='application/pdf'" class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <img v-if="fileUrlList.length>0" class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <embed v-if="file.raw.type=='application/pdf'" class="el-upload-list__item-thumbnail" :src="file.url"  type=""> -->
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleDealImgRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <el-dialog append-to-body :visible.sync="dialogVisible" >
      <img   width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    // 请求参数  附件类型
    fileParam: {
      type: Object,
    },

    //上传图片的最大数量
    limitCountImg: {
      type: Number,
      default: 1,
    },

    // 文件类型信息 多文件上传时使用
    fileTypeInfo: {
      type: Object,
      default: null,
    },

    // 上传文件列表 多文件上传时使用
    fileList: {
      type: Array,
      default: () => [],
    },
    //上传列表,附件回显
    fileUrlList: {
      type: Array,
      default: () => [],
    },
    //判断是调用那个文件上传的接口跟参数
    fileType: {
      type: String,
      default:'0',
    },
    // 文件格式类型
    formatType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showBtnDealImg: true,
      noneBtnImg: false,
      // limitCountImg: 1, //上传图片的最大数量
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      companyUploadList: [],
      // 格式校验
      typeStatus: false,
      removerArr:[],


      // videoUploadPercent: 0, // 动态显示进度条
      // videoFlag: false, // 关闭进度条
      // videoStatus:null
    };
  },
  methods: {
    //图片预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    dealImgChange(file, fileList) {
      if(this.fileTypeInfo){
        file.fileTypeIndex = this.fileTypeInfo.fileTypeIndex
        this.$nextTick(()=>{
          fileList.forEach(item=>{
            if(item.fileTypeIndex == this.fileTypeInfo.fileTypeIndex){
              if(this.fileTypeInfo.removerArr.length==0) 
                  this.fileTypeInfo.removerFileTypeIndex = null
              if(this.fileTypeInfo.removerArr.length){
                this.fileTypeInfo.removerFileTypeIndex == this.fileTypeInfo.removerArr[0]
                this.fileTypeInfo.removerArr.splice(0,1)  
                if(this.fileTypeInfo.removerArr.length){
                  this.fileTypeInfo.fileTypeIndex = this.fileTypeInfo.removerArr[0]
                  this.fileTypeInfo.removerFileTypeIndex = this.fileTypeInfo.removerArr[0]
                }else if(this.fileTypeInfo.removerFileTypeIndex!=null){
                  // this.fileTypeInfo.fileTypeIndex = this.removerArr[0]
                  // this.fileTypeInfo.removerFileTypeIndex = null
                  let arr = [0,1,2,3,4]
                  fileList.forEach(item=>{
                    let index = arr.indexOf(item.fileTypeIndex)
                    arr.splice(index,1)
                  })
                  if(arr.length)
                    this.fileTypeInfo.fileTypeIndex = arr[0]
                }
              }
            }
          })
        })
      }
      this.companyUploadList = fileList;
      this.noneBtnImg = fileList.length >= this.limitCountImg;
    },
    //上传文件之前的钩子
    beforeAvatarUpload(file) {
      // console.log(this.formatType);
      let types=null
      if(this.formatType){
        types = [ "image/jpeg", "image/png"];
      }else{
        types = [ "image/jpeg", "application/pdf", "image/png"];
      }
      const isJPG = types.includes(file.type);
      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isJPG) {
          if(this.formatType){
            this.$message.error("上传图片只能是 JPG/PNG/JPEG 格式!");
          }else{
           this.$message.error("上传图片只能是 JPG/PNG/PDF/JPEG 格式!");
          }
        this.noneBtnImg = false;
      }
      if (!isLt4M) {
        this.$message.error("上传图片大小不能超过 4MB!");
        this.noneBtnImg = false;
      }
      this.typeStatus = true;
      return isJPG && isLt4M;
    },
    //删除文件
    handleDealImgRemove(file) {
      // console.log( this.companyUploadList);
      this.companyUploadList.forEach((item, num) => {
        if (file.uid == item.uid) {
          this.companyUploadList.splice(num, 1);
          this.fileList.splice(num,1)
          if(this.fileTypeInfo){
            this.fileTypeInfo.removerArr.push(item.fileTypeIndex)
            this.removerArr.push(item.fileTypeIndex)
            this.fileTypeInfo.removerArr.sort()
            this.fileTypeInfo.removerArr = [...new Set(this.fileTypeInfo.removerArr)]
            if(this.fileTypeInfo.removerArr.indexOf(item.fileTypeIndex)!=-1&&this.fileTypeInfo.fileTypeIndex>item.fileTypeIndex){
              this.fileTypeInfo.removerFileTypeIndex = item.fileTypeIndex
              this.fileTypeInfo.fileTypeIndex = item.fileTypeIndex
              this.fileTypeInfo.removerFileTypeIndex = item.fileTypeIndex
            }
          }
        }
      });
      this.noneBtnImg = false;

      // this.companyUploadList = [];
      // this.$emit("fileData", null);
      // console.log(this.fileList);
      // console.log(this.companyUploadList);
      // 上传列表 为空
      if (this.companyUploadList.length == 0) {
        this.$emit("fileData", '');
      }
    },
    companyCpload(parent) {
      // console.log(parent);
      // this.videoFlag = true;
      if (!this.typeStatus) {
        this.companyUploadList = [];
        return;
      }
      let formData = new FormData();
      if(this.fileType == '0'){
        formData.append("personCode", this.fileParam.personCode);
        formData.append("file", parent.file);
      }
      else if(this.fileType == '1'){
        formData.append("companyCode", this.fileParam.companyCode);
        formData.append("files", parent.file);
      }
      formData.append("fileType", this.fileParam.fileType);
      // console.log( JSON.parse(localStorage.getItem('info')));
      formData.append("mobile", JSON.parse(localStorage.getItem('info')).mobile);
      if(this.fileType == '0'){
        this.$api.user.companyCpload(formData).then((res) => {
          if (res.code == "1") {
            // this.videoUploadPercent =100;
            // this.videoStatus='success'
            // setTimeout(() => {
            //   this.videoFlag = false;
            // }, 1500);
            // console.log(this.companyUploadList,'companyUploadList');
            // console.log(this.fileTypeInfo.fileTypeIndex,'fileTypeIndex');
            // console.log(this.fileTypeInfo.removerFileTypeIndex,'removerFileTypeIndex');
            // console.log(this.fileTypeInfo.fileTypeIndex,232323);
            if(this.fileTypeInfo){
              if(this.fileTypeInfo.removerArr.length>0){
                res.data.fileTypeIndex = this.removerArr[this.fileTypeInfo.removerArr.length-1]
              }
              else if( this.fileTypeInfo.removerFileTypeIndex!=null){
                res.data.fileTypeIndex = this.removerArr[0]
              }else{
                let arr = [0,1,2,3,4]
                this.fileList.forEach(item=>{
                  let index = arr.indexOf(item.fileTypeIndex)
                  arr.splice(index,1)
                })
                if(arr.length){
                  res.data.fileTypeIndex = arr[0]
                  this.fileTypeInfo.fileTypeIndex = arr[0]
                }
              }
            }
            // console.log(this.companyUploadList,655555555555);
            this.$emit("fileData", res.data);
          } else {
            // let index = null;
            // this.companyUploadList.forEach((item, num) => {
            //   if (parent.name == item.name) {
            //     index = num;
            //   }
            // });
            // this.companyUploadList.splice(index, 1);
            // this.videoFlag = false;
            this.companyUploadList = [];
            this.noneBtnImg = false;
            this.$message.error(res.message);
          }
        }).catch(()=>{
          //  this.videoFlag = false;
        })
      }else if(this.fileType == '1'){
         this.$api.user.oneselfFileUpload(formData).then((res) => {
            // this.videoUploadPercent =100;
            // this.videoStatus='success'
            // setTimeout(() => {
            //   this.videoFlag = false;
            // }, 1500);
          if (res.status == "200") {
            // console.log(this.fileTypeInfo.fileTypeIndex,'fileTypeIndex');
            // console.log(this.fileTypeInfo.removerFileTypeIndex,'removerFileTypeIndex');
            if(this.fileTypeInfo){
              if(this.fileTypeInfo.removerArr.length>0){
                res.data.fileTypeIndex = this.removerArr[this.fileTypeInfo.removerArr.length-1]
              }
              else if( this.fileTypeInfo.removerFileTypeIndex!=null){
                res.data.fileTypeIndex = this.removerArr[0]
              }else{
                let arr = [0,1,2,3,4]
                this.fileList.forEach(item=>{
                  let index = arr.indexOf(item.fileTypeIndex)
                  arr.splice(index,1)
                })
                if(arr.length){
                  res.data.fileTypeIndex = arr[0]
                  this.fileTypeInfo.fileTypeIndex = arr[0]
                }
              }
            }
            this.$emit("fileData", res.data);
          } else {
            // this.videoFlag = false;
            this.companyUploadList = [];
            this.noneBtnImg = false;
            this.$message.error(res.message);
          }
        }).catch(()=>{
          //  this.videoFlag = false;
        })
      }
    },
  },
  watch: {
    fileUrlList: {
      handler(val) {
        if (val.length>0) {
          val.forEach(item=>{
            item.raw={}
            if(item.url.indexOf('.pdf')!=-1){
               item.raw.type='application/pdf'
            }
            if(item.url.indexOf('.jpg')!=-1){
               item.raw.type='image/jpeg'
            }
            if(item.url.indexOf('.jpg')!=-1){
               item.raw.type='image/jpeg'
            }
            if(item.url.indexOf('.png')!=-1){
               item.raw.type='image/png'
            }
          })
          this.$set(this, "companyUploadList", val);
          if(this.limitCountImg=='1'||this.fileUrlList.length==5){
            this.noneBtnImg = true;
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
::v-deep .disUoloadSty .el-upload--picture-card {
  display: none; /* 上传按钮隐藏 */
}
</style>